export default "__VITE_ASSET__D1Ocfs2t__"